import React from "react";
import { Modal } from "antd";
import { withRouter } from "react-router-dom";
import { CloseOutlined, WarningOutlined } from "@ant-design/icons";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      unhandledRejection: false,
    };
  }

  componentDidMount() {
    window.addEventListener("unhandledrejection", this.handlePromiseRejection);
  }

  componentWillUnmount() {
    window.removeEventListener("unhandledrejection", this.handlePromiseRejection);
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error:", error);
    console.error("Error Info:", errorInfo);
    this.setState({ hasError: true });
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevState.hasError || prevState.unhandledRejection) && !this.state.hasError && !this.state.unhandledRejection) {
      setTimeout(() => {
        this.setState({ unhandledRejection: true });
      }, 5000);
    }
  }

  handlePromiseRejection = (event) => {
    console.error("Unhandled promise rejection:", event.reason);
    if (!this.state.hasError) {
      this.setState({ unhandledRejection: true });
    }
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { hasError, unhandledRejection } = this.state;

    if (hasError || unhandledRejection) {
      return (
        <Modal visible footer={null} closable={false} width={450} centered bodyStyle={{ padding: "32px", fontFamily: "Inter, sans-serif", borderRadius: "35px" }}>
          {/* Custom Close Icon */}
          <div style={{ position: "absolute", top: 16, right: 16, cursor: "pointer" }} onClick={this.handleReload}>
            <CloseOutlined style={{ fontSize: "16px", color: "#667085" }} />
          </div>

          {/* Red Icon */}
          <div style={{ display: "flex", justifyContent: "center", marginBottom: "24px" }}>
            <div
              style={{
                width: "48px",
                height: "48px",
                backgroundColor: "#FEE4E2",
                borderRadius: "999px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <WarningOutlined style={{ color: "#D92D20", fontSize: "20px" }} />
            </div>
          </div>

          {/* Title */}
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              color: "#101828",
              marginBottom: "12px",
              textAlign: "left",
            }}
          >
            POS System Error
          </h2>

          {/* Description */}
          <p
            style={{
              fontSize: "14px",
              fontWeight: 400,
              color: "#475467",
              marginBottom: "24px",
              textAlign: "left",
            }}
          >
            Unable to load the POS interface. This may be due to a network issue or system error.
          </p>

          {/* Info box */}
          <div
            style={{
              backgroundColor: "#F9FAFB",
              borderRadius: "8px",
              padding: "12px 16px",
              fontSize: "11px",
              fontWeight: 400,
              color: "#475467",
              marginBottom: "24px",
              textAlign: "center",
            }}
          >
            Click <strong>"Reload POS"</strong> to refresh the system and try again.
          </div>

          {/* Reload Button aligned right */}
          <div style={{ textAlign: "right" }}>
            <button
              onClick={this.handleReload}
              style={{
                backgroundColor: "#2970FF",
                border: "none",
                color: "#FFFFFF",
                padding: "8px 16px",
                fontSize: "14px",
                fontWeight: 500,
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Reload POS
            </button>
          </div>
        </Modal>
      );
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
